import type { ReactNode } from "react";

import { cn } from "../../lib/utils";

export interface EmptyStateProps {
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ title, description, action, className }: EmptyStateProps): JSX.Element {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-slate-200 bg-white p-8 text-center shadow-sm",
        className,
      )}
    >
      <div className="space-y-2">
        <div className="text-base font-semibold text-slate-900">{title}</div>
        {description ? <p className="text-sm text-slate-600">{description}</p> : null}
      </div>
      {action ? <div>{action}</div> : null}
    </div>
  );
}
